import React, { useCallback } from "react";
import {
  ControlledSelect,
  ControlledTextfield,
  ControlledSwitch,
} from "../../../components/inputs";
import { Button, MenuItem } from "../../../components";

const FormUsuario = ({
  props,
  disabled,
  handleSubmit,
  perfil,
  usuario,
  listaSituacoes,
  voltarParaLista,
  perfilUsuario,
  produtos,
}) => {
  const disableField = perfilUsuario !== "ADMINISTRADOR" || disabled;

  const handleClickNext = useCallback(
    (values) => {
      handleSubmit(values, usuario.id);
    },
    [handleSubmit, usuario]
  );

  return (
    <div className="card spacer">
      <div className="card-body">
        <span className="card-title color-brand">Usuário</span>
        <form onSubmit={props.handleSubmit(handleClickNext)}>
          <div className="row">
            <div className="col-12 col-md-6">
              <ControlledTextfield
                name={"codigo"}
                margin={"none"}
                uppercase={false}
                disabled={disableField}
                formProps={props}
                label={"Usuário"}
              />
            </div>
            <div className="col-12 col-md-6">
              <ControlledTextfield
                name={"email"}
                formProps={props}
                uppercase={false}
                disabled={disabled}
                label={"E-Mail"}
                margin={"none"}
              />
            </div>
            <div className="col-12 col-md-6">
              <ControlledTextfield
                formProps={props}
                margin={"none"}
                disabled={disableField}
                name={"nome"}
                label={"Nome"}
                inputProps={{ maxLength: 40 }}
              />
            </div>
            <div className="col-12 col-md-3">
              <ControlledSelect
                name={"perfil"}
                formProps={props}
                disabled={props.getValues("perfil") === 0 || disableField}
                label={"Perfil"}
                margin={"none"}
              >
                {perfil.map((item) => (
                  <MenuItem
                    className={"select-submenu-item"}
                    key={item.id}
                    value={item.id}
                  >
                    {item.nome}
                  </MenuItem>
                ))}
              </ControlledSelect>
            </div>
            <div className="col-12 col-md-3">
              <ControlledSelect
                name={"situacao"}
                formProps={props}
                disabled={disableField}
                label={"Situação"}
                margin={"none"}
              >
                {listaSituacoes.map((item) => (
                  <MenuItem
                    className={"select-submenu-item"}
                    key={item.id}
                    value={item.id}
                  >
                    {item.descricao}
                  </MenuItem>
                ))}
              </ControlledSelect>
            </div>
            <div className="col-12 col-md-6">
              <ControlledSwitch
                formProps={props}
                margin={"none"}
                name={"atividadeExcepcional"}
                label={"Permite Abrir Atividade Excepcional?"}
              />
            </div>
            <div className="col-12 col-md-6">
              <ControlledSelect
                name={"produto"}
                formProps={props}
                multiple={true}
                disabled={disableField}
                label={"Produtos"}
                margin={"none"}
              >
                {produtos.map((item) => (
                  <MenuItem
                    className={"select-submenu-item"}
                    key={item.id}
                    value={item.id}
                  >
                    {item.nome}
                  </MenuItem>
                ))}
              </ControlledSelect>
            </div>
          </div>
          <div className="row spacer">
            <div className="offset-md-2 col-md-4 col-12">
              <Button
                label="Voltar"
                onClick={voltarParaLista}
                loading={usuario.loading}
              />
            </div>

            {perfilUsuario === "ADMINISTRADOR" && (
              <div className="col-md-4 col-12">
                <Button
                  label="CONFIRMAR"
                  type={"submit"}
                  loading={usuario.loading}
                />
              </div>
            )}
            {perfilUsuario === "BPO" && (
              <div className="col-md-4 col-12">
                <Button
                  label="REENVIAR E-MAIL"
                  type={"submit"}
                  loading={usuario.loading}
                />
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormUsuario;
